import { Button } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import '../../App.css'
import { apiUrlPrefix } from '../../config';
import Cookies from 'js-cookie';
import { useNavigate, Link } from 'react-router-dom';
import useStore from './state-files/zustondStoreStates';

const LogoutWidget = () => {
  const queryClient = useQueryClient(); // Access React Query's client
  const {setIsLoggedIn} = useStore();
  const navigate = useNavigate();

  // Handle login button click (you can integrate this with your API later)
  const handleLogout = async () => {
    const apiUrl = apiUrlPrefix + "MongoDb/Logout";
    try {
      await fetch(apiUrl, {
        method: 'POST',
        credentials: 'include'
      });
      localStorage.removeItem('accessToken');
      localStorage.removeItem('profilePicture');
      localStorage.removeItem('roles');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('refreshTokenExpiry');
      localStorage.removeItem('userId');
      localStorage.removeItem('username');
      Cookies.remove('userId');
      Cookies.remove('username');
      setIsLoggedIn(false);
      navigate('/', { replace: true });
    } catch (error) {
      console.error('Failed to logout:', error);
    }
  };

  return (
    <div>
      <Button id="logoutButton" variant="contained"
        color="none" onClick={handleLogout} style={{ boxShadow: "none" }}>
        Logout
      </Button>
    </div>
  );
};

export default LogoutWidget;